import { ICommunitySort } from '../store/types/community';

export const COMMUNITY_RECENT_PER_PAGE = 5;
export const COMMUNITY_SORT = 'community-sort';
export const COMMUNITY_ANSWERS_SORT = 'community-answers-sort';
export const COMMUNITY_VOTED_QUESTIONS = 'community-voted-questions';
export const COMMUNITY_VOTED_ANSWERS = 'community-voted-answers';

export const SORT_LIST: ICommunitySort[] = [
  { value: 'created_at', label: 'COMMUNITY.SORT.DATE' },
  { value: 'views', label: 'COMMUNITY.SORT.VIEWS' },
  { value: 'answers_count', label: 'COMMUNITY.SORT.ANSWERS' },
  { value: 'rating', label: 'COMMUNITY.SORT.RATING' },
];

export const SORT_ANSWERS_LIST: ICommunitySort[] = [
  { value: 'desc', label: 'COMMUNITY.SORT.NEWEST' },
  { value: 'asc', label: 'COMMUNITY.SORT.OLDEST' },
];

export const CORRECT_ANSWER_STATUS = 3;

interface IIconsNames {
  [key: string]: string;
}

export const ICON_NAMES: IIconsNames = {
  'feature-requests': 'colored--32--bot-default-color',
  'bug-reports': 'colored--32--sent-documents-declined',
  'general-discussion': 'colored--32--sms',
};

interface IStatusColors {
  [key: string]: string;
}

export const STATUS_COLORS: IStatusColors = {
  null: 'orange',
  0: 'red',
  2: 'green',
  3: 'blue',
};
